import { useMutation } from 'react-query';
import axios from 'axios';

import api from '@src/utils/api';
import { UPLOAD_ASSETS } from '@src/hooks/react-query/queries';

const uploadToPresignedUrl = ({ presignedUrl, file }) => {
  return axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });
};

export const useUploadToPresignedUrl = () => useMutation(uploadToPresignedUrl);

const fetchUploadPresignedUrl = (payload) => {
  const { asset_type, mimeType, extension, organizationId } = payload;
  return api.post(`${UPLOAD_ASSETS}?asset_type=${asset_type}`, { mimeType, extension, organizationId });
};

export const useFetchUploadPresignedUrl = (payload) => {
  return useMutation(
    [`${UPLOAD_ASSETS}?asset_type=${payload?.asset_type}`],
    fetchUploadPresignedUrl
  );
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useAssetUpload.js